import { useCallback, useState } from "react";

export type SnackbarSeverity = "success" | "error" | "info" | "warning";

export type SnackbarState = {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
};

export const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: "",
    severity: "success",
  });

  const showSuccess = useCallback((message: string) => {
    setSnackbar({ open: true, message, severity: "success" });
  }, []);

  const showError = useCallback((message: string) => {
    setSnackbar({ open: true, message, severity: "error" });
  }, []);

  const close = useCallback(() => {
    setSnackbar((s) => ({ ...s, open: false }));
  }, []);

  return { snackbar, showSuccess, showError, close };
};

export default useSnackbar;
